import { Spreadsheet } from '@/components/spreadsheet/spreadsheet';
import { dateService } from '@/services';
import * as _ from 'lodash';
import * as moment from 'moment';

export class DapSpreadsheetMarketShareInfluence extends Spreadsheet {
  name: string = 'market_share_influence';

  mount(dataSource: any[]) {
    dataSource = dataSource.map(function(f) {
      f.productSales3s = f.storeType === '3S' ? f.salesInSegment : 0;
      f.productSales2s = f.storeType === '2S' ? f.salesInSegment : 0;
      return f;
    });

    const totalMonths = dataSource[0].dapValuesFoundNormalized.length;
    const initialValue = 31;

    const sections: Array<any> = [
      { key: 'main', text: '', index: 0 },
      { key: 'updated', text: 'UPDATED', index: 12 },
      { key: 'industryRegistration', text: 'INDUSTRY REGISTRATION', index: 13 },
      { key: 'clientRegistration', text: 'TOYOTA REGISTRATION', index: 16 },
      { key: 'dealerPerformance', text: 'DEALER PERFORMANCE', index: 18 },
      { key: 'referenceMktShare', text: 'REFERENCE MKT-SHARE', index: 23 },
      { key: 'dnc', text: 'SALES GAP', index: 27 },
      { key: 'dapValuesFoundNormalized', text: 'MONTHLY ANNUAL PLAN - TDB SHARE NORMALIZATION', index: initialValue },
      { key: 'dapValuesFound', text: 'MONTHLY ANNUAL PLAN', index: initialValue + (totalMonths || 1) },
      { key: 'dapValuesForecast', text: 'MARKET SHARE FORECAST', index: initialValue + (totalMonths * 2 || 2) }
    ];

    const sectionColumns: any = {
      main: [
        { key: 'dealerNumber', text: 'DN' },
        { key: 'dealerName', text: 'NAME' },
        { key: 'storeType', text: 'TYPE' },
        { key: 'groupName', text: 'GROUP' },
        { key: 'dealerNumberMatrix', text: 'DN MATRIX' },
        { key: 'dealerNumberMatrixBefore', text: 'DN MATRIX BEFORE' },
        { key: 'markedAreaName', text: 'MARKED AREA' },
        { key: 'region', text: 'REGION' },
        { key: 'aov', text: 'AOV' },
        { key: 'regionale', text: 'REGIONAL' },
        { key: 'marketLevel', text: 'MARKET SHARE REFERENCE' },
        { key: 'segmentName', text: 'SEGMENT' }
      ],
      updated: [{ key: 'dateConversion', text: 'DATA CONVERT', textAlign: 'center' }],
      industryRegistration: [
        { key: 'industryRetailRegistration', text: 'INDUSTRY RETAIL REGISTRATION', format: '#,0' },
        { key: 'industryRegistrationInSegment', text: 'INDUSTRY RETAIL REGISTRATION IN SEGMENT', format: '#,0' },
        { key: 'percentSegmentInIndustryRetail', text: '% SEGMENT IN INDUSTRY RETAIL', format: '#0.0%' }
      ],
      clientRegistration: [
        { key: 'clientRetailRegistrationInSegment', text: 'TOYOTA RETAIL REGISTRATION IN SEGMENT', format: '#,0' },
        { key: 'clientMarketShareInSegment', text: 'MKT-SHARE TOYOTA IN SEGMENT', format: '#0.0%' }
      ],
      dealerPerformance: [
        { key: 'qtdMonthsWithSales', text: 'QTD MONTHS', format: '#,0' },
        { key: 'productSales3s', text: 'PRODUCT SALES ORGN (3S)', format: '#,0' },
        { key: 'productSales2s', text: 'PRODUCT SALES ORGN (2S)', format: '#,0' },
        { key: 'productSales', text: 'PRODUCT SALES', format: '#,0' },
        { key: 'indexUnderSalesInSegment', text: 'INDEX UNDER AD SALES IN PRODUCT', format: '#0.0%' },
        {
          key: 'indexUnderNationalSalesInSegment',
          text: 'INDEX UNDER NATIONAL SALES IN PRODUCT',
          color: 'yellow',
          format: '#0.00%'
        }
      ],
      referenceMktShare: [
        { key: 'upperLimit', text: 'UPPER LIMIT', format: '#0.0%' },
        { key: 'averageLimit', text: 'AVERAGE LIMIT', format: '#0.0%' },
        { key: 'lowerLimit', text: 'LOWER LIMIT', format: '#0.0%' }
      ],
      dnc: [
        { key: 'dncInSegment', text: 'SALES GAP IN PRODUCT', format: '#,0' },
        { key: 'newSalesInSegment', text: 'NEW SALES IN PRODUCT', format: '#,0' },
        {
          key: 'newIndexUnderNationalSalesInSegment',
          text: 'NEW INDEX UNDER NATIONAL SALES N PRODUCT',
          color: 'yellow',
          format: '#0.00%'
        },
        { key: 'indexVariation', text: 'INDEX - VARIATION', format: '#0.00%' }
      ],
      dapValuesFoundNormalized: [
        ..._.map(dataSource[0].dapValuesFoundNormalized, () => ({ key: 'value', text: 'SALES GOAL', format: '#0.00%' }))
      ],
      dapValuesFound: [
        ..._.map(dataSource[0].dapValuesFound, () => ({ key: 'value', text: 'SALES GOAL', format: '#,0' }))
      ],
      dapValuesForecast: [
        ..._.map(dataSource[0].dapValuesForecast, () => ({ key: 'value', text: 'MKT-SHARE FCST', format: '#0.00%' }))
      ]
    };

    const sectionColumnsDateTime: any = {
      main: [{ key: 'dealerNumber', text: '' }],
      updated: [{ key: 'modificationHistory', text: '' }],
      industryRegistration: [
        {
          key: 'industryRetailRegistration',
          text: `${dateService
            .parseDateToString(dataSource[0].initialHistoryPeriod, 'MMM/YY')
            .toUpperCase()} - ${dateService
            .parseDateToString(dataSource[0].finalHistoryPeriod, 'MMM/YY')
            .toUpperCase()}`
        }
      ],
      clientRegistration: [],
      dealerPerformance: [],
      referenceMktShare: [],
      dnc: [],
      dapValuesFoundNormalized: [
        ..._(dataSource[0].dapValuesFoundNormalized)
          .map((d: any, i: number) => ({ key: 'year', text: String(d.year), index: initialValue + i }))
          .uniqBy((d: any) => d.text)
          .value()
      ],
      dapValuesFound: [
        ..._(dataSource[0].dapValuesFound)
          .map((d: any, i: number) => ({
            key: 'year',
            text: String(d.year),
            index: initialValue + (totalMonths || 1) + i
          }))
          .uniqBy((d: any) => d.text)
          .value()
      ],
      dapValuesForecast: [
        ..._(dataSource[0].dapValuesForecast)
          .map((d: any, i: number) => ({
            key: 'year',
            text: String(d.year),
            index: initialValue + (totalMonths * 2 || 1) + i
          }))
          .uniqBy((d: any) => d.text)
          .value()
      ]
    };

    const sectionColumnsDescription: any = {
      main: [{ key: 'dealerNumber', text: '' }],
      updated: [{ key: 'modificationHistory', text: '' }],
      industryRegistration: [
        { key: 'industryRetailRegistration', text: 'A' },
        { key: 'industryRetailRegistration', text: 'B' },
        { key: 'segmentInIndustryRetail', text: 'C=B/A' }
      ],
      clientRegistration: [
        { key: 'clientRetailRegistrationInSegment', text: 'D' },
        { key: 'clientMarketShareInSegment', text: 'E=D/B' }
      ],
      dealerPerformance: [
        { key: 'qtdMonthsWithSales', text: 'F' },
        { key: 'productSales3s', text: 'G' },
        { key: 'productSales2s', text: 'H' },
        { key: 'productSales', text: 'I' },
        { key: 'indexUnderSalesInSegment', text: 'J=I/∑SALES AD' },
        { key: 'indexUnderNationalSalesInSegment', text: 'K=I/∑SALES TT', color: 'yellow' }
      ],
      referenceMktShare: [
        { key: 'upperLimit', text: 'L' },
        { key: 'averageLimit', text: 'L' },
        { key: 'lowerLimit', text: 'L' }
      ],
      dnc: [
        { key: 'dncInSegment', text: 'M=[(L*I)/E]-I' },
        { key: 'newSalesInSegment', text: 'N=M=I' },
        { key: 'newIndexUnderNationalSalesInSegment', text: 'O=M/∑SALES TT', color: 'yellow' },
        { key: 'indexVariation', text: 'P' }
      ],
      dapValuesFoundNormalized: [
        ..._.map(dataSource[0].dapValuesFoundNormalized, d => ({
          key: 'month',
          text: moment()
            .startOf('year')
            .add(d.month - 1, 'months')
            .format('MMM')
            .toUpperCase()
        }))
      ],
      dapValuesFound: [
        ..._.map(dataSource[0].dapValuesFound, d => ({
          key: 'month',
          text: moment()
            .startOf('year')
            .add(d.month - 1, 'months')
            .format('MMM')
            .toUpperCase()
        }))
      ],
      dapValuesForecast: [
        ..._.map(dataSource[0].dapValuesForecast, d => ({
          key: 'month',
          text: moment()
            .startOf('year')
            .add(d.month - 1, 'months')
            .format('MMM')
            .toUpperCase()
        }))
      ]
    };

    const baseStyle: any = {
      textAlign: 'left',
      fontSize: 9,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseHeaderStyle: any = {
      color: '#212121',
      fontSize: 9,
      bold: true,
      textAlign: 'center',
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseColorStyle: any = {
      main: '#bdbdbd',
      industryRegistration: '#90a4ae',
      clientRegistration: '#e57373',
      dealerPerformance: '#90a4ae',
      referenceMktShare: '#e57373',
      dnc: '#90a4ae',
      dapValuesFoundNormalized: '#e57373',
      dapValuesFound: '#90a4ae',
      dapValuesForecast: '#81c784',
      grey: '#d1d1d1',
      greyDarken: '#c1c1c1',
      updated: '#81c784',
      yellow: '#ffb74d'
    };

    const baseBorderColorStyle: any = {
      main: '#e0e0e0',
      industryRegistration: '#cfd8dc',
      clientRegistration: '#ffcdd2',
      dealerPerformance: '#cfd8dc',
      referenceMktShare: '#ffcdd2',
      dnc: '#cfd8dc',
      dapValuesFoundNormalized: '#ffcdd2',
      dapValuesFound: '#cfd8dc',
      dapValuesForecast: '#c8e6c9',
      updated: '#c8e6c9',
      yellow: '#ffe0b2'
    };

    const baseBackgroundColorStyle: any = {
      main: '#fafafa',
      industryRegistration: '#f9fafb',
      clientRegistration: '#fff5f6',
      dealerPerformance: '#f9fafb',
      referenceMktShare: '#fff5f6',
      dnc: '#f9fafb',
      dapValuesFoundNormalized: '#fff5f6',
      dapValuesFound: '#f9fafb',
      dapValuesForecast: '#f4f9f5',
      updated: '#f4f9f5',
      yellow: '#fffbf5'
    };

    const headerStyle = _.reduce(
      baseColorStyle,
      (acc: any, val: string, key: string) => {
        acc[key] = _.assign({}, baseHeaderStyle, { background: baseColorStyle[key] });
        return acc;
      },
      {}
    );

    const getCellStyle = (key: any) => {
      return _.assign({}, baseStyle, {
        textAlign: 'center',
        background: baseBackgroundColorStyle[key],
        borderLeft: { color: baseBorderColorStyle[key], size: 1 },
        borderRight: { color: baseBorderColorStyle[key], size: 1 },
        borderTop: { color: baseBorderColorStyle[key], size: 1 },
        borderBottom: { color: baseBorderColorStyle[key], size: 1 }
      });
    };

    const dataSourceGroup = _(dataSource)
      .groupBy(d => d.familyName)
      .value();

    this.name = `dap_${_.map(dataSourceGroup, (val: any, key: string) => key.toLowerCase()).join('_')}_${this.name}`;

    this.workbookOptions = {
      sheets: _.map(
        dataSourceGroup,
        (data: any, name: string) =>
          ({
            name: `MS IDEAL ${name}`.toUpperCase(),
            frozenColumns: 2,
            frozenRows: 4,
            filter: {
              ref: `A4:${this.columnIndex[initialValue - 1 + totalMonths * 3]}${data.length + 4}`,
              columns: []
            },
            rows: [
              {
                cells: [
                  ..._.map(sections, (section: any) =>
                    _.assign({}, headerStyle[section.key], {
                      value: section.text,
                      index: section.index,
                      borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                      borderRight: { color: baseBorderColorStyle[section.key], size: 1 }
                    })
                  )
                ]
              },
              {
                cells: [
                  ..._(sectionColumnsDateTime)
                    .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                        _.assign({}, getCellStyle(cell.color || key), {
                          value: cell.text,
                          bold: true,
                          index: cell.index,
                          background: baseColorStyle.grey,
                          borderLeft: { color: baseBorderColorStyle.main, size: 1 },
                          borderRight: { color: baseBorderColorStyle.main, size: 1 },
                          borderTop: { color: baseBorderColorStyle.main, size: 1 },
                          borderBottom: { color: baseBorderColorStyle.main, size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              {
                cells: [
                  ..._(sectionColumnsDescription)
                    .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                        _.assign({}, getCellStyle(cell.color || key), {
                          value: cell.text,
                          bold: true,
                          background: baseColorStyle.greyDarken,
                          borderLeft: { color: baseBorderColorStyle.main, size: 1 },
                          borderRight: { color: baseBorderColorStyle.main, size: 1 },
                          borderTop: { color: baseBorderColorStyle.main, size: 1 },
                          borderBottom: { color: baseBorderColorStyle.main, size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              {
                height: 80,
                cells: [
                  ..._(sectionColumns)
                    .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                        _.assign({}, headerStyle[cell.color || key], {
                          value: cell.text,
                          wrap: true,
                          borderLeft: { color: baseBorderColorStyle[cell.color || key], size: 1 },
                          borderRight: { color: baseBorderColorStyle[cell.color || key], size: 1 },
                          borderTop: { color: baseBorderColorStyle[cell.color || key], size: 1 },
                          borderBottom: { color: baseBorderColorStyle[cell.color || key], size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              ..._.map(data, d => {
                return {
                  cells: [
                    ..._(sectionColumns)
                      .map((columns: any, key: any) =>
                        _.map(columns, (cell: any, index: number) => {
                          if (
                            key === 'dapValuesFoundNormalized' ||
                            key === 'dapValuesFound' ||
                            key === 'dapValuesForecast'
                          ) {
                            return _.assign({}, getCellStyle(cell.color || key), {
                              value: d[key][index][cell.key],
                              format: cell.format
                            });
                          }
                          return _.assign({}, getCellStyle(cell.color || key), {
                            value: d[cell.key],
                            format: cell.format,
                            textAlign: cell.textAlign || 'center'
                          });
                        })
                      )
                      .flatten()
                      .value()
                  ]
                };
              })
            ],
            columns: [
              {
                index: 0,
                width: 100
              },
              {
                index: 1,
                width: 160
              },
              {
                index: 2,
                width: 100
              },
              {
                index: 3,
                width: 100
              },
              {
                index: 4,
                width: 100
              },
              {
                index: 5,
                width: 200
              },
              {
                index: 6,
                width: 120
              },
              ..._.map(_.range(0, dataSource.length - 7), index => ({
                index: index + 7,
                width: 75
              }))
            ],
            showGridLines: false,
            mergedCells: [
              `A1:${this.columnIndex[sectionColumns.main.length - 1]}1`,
              `A2:${this.columnIndex[sectionColumns.main.length - 1]}2`,
              `A3:${this.columnIndex[sectionColumns.main.length - 1]}3`,
              `${this.columnIndex[sections[1].index]}2:${this.columnIndex[sections[2].index - 1]}2`,
              `${this.columnIndex[sections[2].index]}2:${this.columnIndex[sections[7].index - 1]}2`,
              `${this.columnIndex[sections[1].index]}1:${this.columnIndex[sections[2].index - 1]}1`,
              `${this.columnIndex[sections[2].index]}1:${this.columnIndex[sections[3].index - 1]}1`,
              `${this.columnIndex[sections[3].index]}1:${this.columnIndex[sections[4].index - 1]}1`,
              `${this.columnIndex[sections[4].index]}1:${this.columnIndex[sections[5].index - 1]}1`,
              `${this.columnIndex[sections[5].index]}1:${this.columnIndex[sections[6].index - 1]}1`,
              `${this.columnIndex[sections[6].index]}1:${this.columnIndex[sections[7].index - 1]}1`,
              `${this.columnIndex[sections[7].index]}1:${this.columnIndex[sections[8].index - 1]}1`,
              `${this.columnIndex[sections[8].index]}1:${this.columnIndex[sections[8].index + totalMonths - 1]}1`,
              `${this.columnIndex[sections[9].index]}1:${this.columnIndex[sections[9].index + totalMonths - 1]}1`,
              ..._.map(
                sectionColumnsDateTime.dapValuesFoundNormalized,
                (c: any) =>
                  `${this.columnIndex[c.index]}2:${
                    this.columnIndex[
                      c.index -
                        1 +
                        (_(dataSource[0].dapValuesFoundNormalized)
                          .groupBy((d: any) => d.year)
                          .find((val: any, key: string) => +key === +c.text) as any).length
                    ]
                  }2`
              ),
              ..._.map(
                sectionColumnsDateTime.dapValuesFound,
                (c: any) =>
                  `${this.columnIndex[c.index]}2:${
                    this.columnIndex[
                      c.index -
                        1 +
                        (_(dataSource[0].dapValuesFound)
                          .groupBy((d: any) => d.year)
                          .find((val: any, key: string) => +key === +c.text) as any).length
                    ]
                  }2`
              ),
              ..._.map(
                sectionColumnsDateTime.dapValuesForecast,
                (c: any) =>
                  `${this.columnIndex[c.index]}2:${
                    this.columnIndex[
                      c.index -
                        1 +
                        (_(dataSource[0].dapValuesForecast)
                          .groupBy((d: any) => d.year)
                          .find((val: any, key: string) => +key === +c.text) as any).length
                    ]
                  }2`
              )
            ]
          } as any)
      )
    };

    return this;
  }
}
